const type = 'SET_CUSTOMER_DUE_DATES';

const setCustomerDueDates = (data) => ({
  type,
  data,
});

export { type };
export default setCustomerDueDates;
